<template>
	<div id="LotChurchListComponent">
		<button @click="getAllLotChurchsLocal(1)" ref="btnGetAllLotChurchs" v-show="false">buscar</button>
		<nav class="navbar navbar-light bg-light" v-if="lot.id > -1">
			<div class="navbar-text">
				<span>ID: <b>{{lot.id}}</b></span>
				<span> - Usuario: <b>{{lot.user.name}}</b></span>
				<span> - Campo: <b>{{lot.entity.name}}</b></span>
			</div>
			<div class="navbar-text">
				{{lot.created_at}}
			</div>
		</nav>
		<table class="table table-sm table-12">
			<thead>
				<tr>
					<th class="text-center">#</th>
					<th class="text-center">Lote</th>
					<th class="text-center">Iglesia</th>
					<th class="text-center">Observación</th>
					<th class="text-center">Envio de suscripción</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in listLotChurchs" :key="index" :class="(item.order_id == null) ? 'text-danger' : ''">
					<td class="text-center">{{item.id}}</td>
					<td>{{item.lor_id}}</td>
					<td>{{item.church.type_church.name}} {{item.church.name}}</td>
					<td>{{item.observation}}</td>
					<td class="text-center">
						<span v-if="item.order_id != null">
							<router-link :to="'/order/' + item.order_id" target="_blank" v-if="item.order != null">
								<del v-if="item.order.status_id == 37" class="text-danger" title="anulado">
									{{item.order_id}}
								</del>
								<span v-else>
									{{item.order_id}}
								</span>
							</router-link>
							<span v-else>Error</span>
						</span>
					</td>
					<td>
						<span v-if="item.order != null">
							<i class="far fa-times-circle pointer text-warning" v-if="item.order.status_id == 56" title="Volver atras" @click="goBackSendSubscriptionLocal(item)"></i>
						</span>
					</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
import mixin from '@/mixins'
import errors from '@/mixins/errors.js'
import axiosAction from '@/mixins/axiosAction.js'
import lotChurchs from '@/mixins/lots/lotChurch.js'

export default {
	name: 'LotChurchListComponent',
	mixins: [axiosAction, errors, mixin, lotChurchs],
	props: ['lot'],
	data () {
		return {
		}
	},
	computed: {
	},
	methods: {
		getAllLotChurchsLocal(page = 1) {
			this.getAllLotChurchs(this.lot.id)
		},
		getAllLotChurchsResultLocal(response) {
			console.log(response.data.data)
			response.data.data.forEach(el => {
				console.log(el, el.order_id, el.status_id)
			})
		},
		goBackSendSubscriptionLocal(item) {
			if(item.order.status_id == 56) {
				this.goBackSendSubscription(item.id)	
			}
		},
		goBackSendSubscriptionResultLocal(response) {
			if(response.data.success == true) {
				let index = this.listLotChurchs.map(el => parseInt(el.order_id)).indexOf(parseInt(response.data.data.order_id))
				if(index > -1) {
					this.listLotChurchs[index].order.status_id = response.data.data.statu.id
				}
				this.$snotify.success('Envío de Suscrpción Nº ' + response.data.data.order_id + ' Cancelada ', 'Realizado')
			} else {
				this.$snotify.warning(response.data.data, response.data.message)
			}
		},
		resultAxiosLocal(responseLocal, response) {
			this.$emit('hideLockScreen')
			switch(responseLocal) {
				case 'getAllLotChurchsResult': this.getAllLotChurchsResult(response); break;
				case 'goBackSendSubscriptionResult': this.goBackSendSubscriptionResult(response); break;
		        default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')'); break;
			}
		},
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
</style>
